import { PagePlatformEdit } from '~/app/pages/User/Platforms/Edit';

import { PagePlatforms } from './Overview';

export const PLATFORMS = {
  Platforms: PagePlatforms,
  PlatformEdit: PagePlatformEdit,
} as const;
